
import { Box, Grid, GridItem, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'
import type { ApiLogDetail } from 'BrokerTsLib/src/dtos/Api/ApiLog'
import { getProductShortName } from 'BrokerTsLib/src/enums'
import { ApiLogHeaders } from './ApiLogHeaders'
import { JsonViewer } from './JsonViewer'


export const LogDetail = ({ apiLogDetail: data }: { apiLogDetail: ApiLogDetail }) => {
    const rows: LabelValueGridRow[] = data ? [
        ['LogId', data.id],
        ['Offers', data.offerIds || ''],
        ['Action', data.action],
        ['Requested', data.requestUtc?.toLocaleString()],
        ['Responded', data.responseUtc?.toLocaleString()],
        ['Status', data.statusCode],
        ['UserId', data.userId],
        ['Product', data.product ? getProductShortName(data.product) : ''],
        ['AbsoluteUri', data.absoluteUri],
        ['RequestId', data.requestId],
        ['ParamsId', data.insuranceParamsId || ''],
        ['Url', data.absoluteUriAbbreviated || ''],
        ['IP', data.host],
        ['Username', data.username || ''],
        ['Partner', data.partner || ''],
        ['Authorization', extractBearerToken(data.headers) || '', true],
    ] : []


    return (
        <Grid gap={8}>
            <LabelValueGrid rows={rows} />

            <Box bg="gray.700" color="white" p={0}>
                <Tabs variant="unstyled">
                    <TabList borderBottom="1px solid" borderColor="gray.500">
                        <Tab _selected={{ bg: 'gray.600', fontWeight: 'bold' }} px={6}>Request</Tab>
                        <Tab _selected={{ bg: 'gray.600', fontWeight: 'bold' }} px={6}>Response</Tab>
                        <Tab _selected={{ bg: 'gray.600', fontWeight: 'bold' }} px={6}>Headers</Tab>
                    </TabList>

                    <TabPanels bg="white" color="black">
                        <TabPanel>
                            <BorderedWrapper>
                                <JsonViewer jsonString={data.requestBody} />
                            </BorderedWrapper>
                        </TabPanel>
                        <TabPanel>
                            <BorderedWrapper>
                                <JsonViewer jsonString={data.responseBody} />
                            </BorderedWrapper>
                        </TabPanel>
                        <TabPanel>
                            <ApiLogHeaders apiLogDetail={data} />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Grid>
    )
}

const BorderedWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box borderWidth="1px" borderRadius="md" p={4}>
            {children}
        </Box>
    )
}


function extractBearerToken(headers: string): string | null {
    const authLine = headers
        ?.split('\r\n')
        .find(line => line.toLowerCase().startsWith('authorization: '))

    if (!authLine) return null

    const token = authLine.slice('Authorization: '.length).trim()
    return token || null
}


type LabelValueGridRow = [string, React.ReactNode, boolean?]

interface LabelValueGridProps {
    rows: LabelValueGridRow[]
}

export const LabelValueGrid = ({ rows }: LabelValueGridProps) => {
    return (
        <BorderedWrapper>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                {rows.map(([label, value, wide], i) => (
                    <Grid templateColumns="150px 1fr" key={i} as={GridItem} colSpan={wide ? 2 : 1}>
                        <Text fontWeight="semibold" whiteSpace="nowrap">
                            {label}
                        </Text>
                        <Text wordBreak="break-all">{value}</Text>
                    </Grid>
                ))}
            </Grid>
        </BorderedWrapper>
    )
}